import { fromJS } from "immutable"
import {
    loadStanceCustomLabelsActionDict,
} from "shared/stance/action-types"

const initialState = fromJS({
    isLoading: false,
    stanceCustomLabels: undefined,
})

const stanceReducer = (state = initialState, action) => {
    switch (action.type) {
        case loadStanceCustomLabelsActionDict.start:
            return state
                .set("isLoading", true)
        case loadStanceCustomLabelsActionDict.success:
            return state
                .set("stanceCustomLabels", fromJS(action.response.objects))
                .set("isLoading", false)
        case loadStanceCustomLabelsActionDict.fail:
            return state
                .set("isLoading", false)
        default:
            return state
    }
}

export default stanceReducer
